module.exports = __webpack_public_path__ + "img/ic_goals.dee9eb67.png";